import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
//import { Col } from 'react-bootstrap/Form'
import { Form, Card, Button, Col, Jumbotron, OverlayTrigger, Tooltip, Nav } from 'react-bootstrap';
import Menu from '../menu'
import errores from '../../middleware/errordb'
import funciones from '../../middleware/funciones'
import back from '../../back.svg';
import config from '../../config';
//import funciones from '../../middleware/funciones';
import Mensajes from '../subcomponent/mensajes';
//import Modal from '../subcomponent/modal';
//import Vendedores from '../usuarios';
import ModalConfirm from '../subcomponent/modalConfirm';

class Formularioclientes extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        this.state = {
            titulo: "Crear Empleados",
            msg: 0,
            comp: "",
            id_empleados: "",
            empresa: currentCompany,
            ID_EMPRESA: currentCompany,
            CODIGO_TIPO_EMPLEADO: 0,
            TIPO_EMPLEADO: 0,
            CODIGO_SUBTIPO_EMPLEADO: 0,
            SUBTIPO_EMPLEADO: 0,
            ALTO_RIESGO: "",
            TIPO_DOCUMENTO: 0,
            AUXILIO_TRANSPORTE: 0,
            DOCUMENTO_EMPLEADO: "",
            NOMBRE_1: "",
            NOMBRE_2: "",
            APELLIDO_1: "",
            APELLIDO_2: "",
            NOMBRE_COMPLETO: "",
            CODIGO_PAIS: "",
            CODIGO_DEPARTAMENTO_EMPLEADO: "",
            NOMBRE_DEPARTAMENTO_EMPLEADO: "",
            NOMBRE_CIUDAD_EMPLEADO: "",
            CODIGO_MUNICIPIO_EMPLEADO: "",
            DIRECCION_EMPLEADO: "",
            SALARIO_INTEGRAL: "",
            TIPO_CONTRATO: "",
            CODIGO_TIPO_CONTRATO: "",
            SUELDO_EMPLEADO: "",
            TELEFONO_EMPLEADO: "",
            MEDIO_PAGO: "",
            CODIGO_MEDIO_PAGO: "",
            BANCO: "",
            CODIGO_BANCO: "",
            TIPO_CUENTA: "",
            NUMERO_CUENTA: "",
            CODIGO_ENTIDAD_SALUD: "",
            DESCRIPCION_ENTIDAD_SALUD: "",
            CODIGO_ENTIDAD_PENSION: "",
            DESCRIPCION_ENTIDAD_PENSION: "",
            VALOR_CESANTIAS: "",
            VALOR_PENSION: " ",
            VALOR_SALUD: " ",
            CORREO_EMPLEADO: " ",
            FECHA_INGRESO: null,
            FECHA_RETIRO: null,
            USAR_NORMA_LEY: 1,
            ciudades: [],
            departamentos: [],
            listas: [],
            medios_pago: [],
            tipos_empleados: [],
            subtipos_empleados: [],
            bancos: [],
            tipo: currentUserType,
            mostrarMensaje: false,
            mensaje: "",
            mensajeConfirm: " "
        }
    }

    componentDidMount() {
        const { search } = this.props.location;
        let titulo = "";
        let id_empleados = "";
        const categoriaEdicion = search.replace('?', '');
        if (categoriaEdicion) {
            titulo = "Modificar Empleados";
            id_empleados = categoriaEdicion;
        } else {
            titulo = "Crear Empleados";
            id_empleados = "0";
        }
        //console.log(id_empleados)
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/employee/' + id_empleados, datasend).then(response => response.json())
            .then(data => {
                //console.log(data)
                if (data.ok) {
                    const datosAll = data.data;
                    const datos = datosAll[0];
                    const ciudades = datosAll[1];
                    const departamentos = datosAll[2];
                    const medios_pago = datosAll[3];
                    const bancos = datosAll[4];
                    const tipos_empleados = datosAll[5];
                    const subtipos_empleados = datosAll[6];
                    this.setState({

                        //descripcion: datos[0]["CODIGO_EMPRESA"],
                        ID_EMPLEADO: (id_empleados === "0") ? "" : datos[0]["ID_EMPLEADO"],
                        //ID_EMPRESA: (id_empleados === "0")?"": datos[0]["ID_EMPRESA"],
                        CODIGO_TIPO_EMPLEADO: (id_empleados === "0") ? "" : datos[0]["CODIGO_TIPO_EMPLEADO"],
                        CODIGO_SUBTIPO_EMPLEADO: (id_empleados === "0") ? "" : datos[0]["CODIGO_SUBTIPO_EMPLEADO"],
                        TIPO_EMPLEADO: (id_empleados === "0") ? "" : datos[0]["TIPO_EMPLEADO"],
                        SUBTIPO_EMPLEADO: (id_empleados === "0") ? "" : datos[0]["SUBTIPO_EMPLEADO"],
                        ALTO_RIESGO: (id_empleados === "0") ? "" : datos[0]["ALTO_RIESGO"],
                        TIPO_DOCUMENTO: (id_empleados === "0") ? "" : datos[0]["TIPO_DOCUMENTO"],
                        DOCUMENTO_EMPLEADO: (id_empleados === "0") ? "" : datos[0]["DOCUMENTO_EMPLEADO"],
                        NOMBRE_1: (id_empleados === "0") ? "" : datos[0]["NOMBRE_1"],
                        NOMBRE_2: (id_empleados === "0") ? "" : datos[0]["NOMBRE_2"],
                        APELLIDO_1: (id_empleados === "0") ? "" : datos[0]["APELLIDO_1"],
                        APELLIDO_2: (id_empleados === "0") ? "" : datos[0]["APELLIDO_2"],
                        CODIGO_PAIS: (id_empleados === "0") ? "" : datos[0]["CODIGO_PAIS"],
                        CODIGO_DEPARTAMENTO_EMPLEADO: (id_empleados === "0") ? "" : datos[0]["CODIGO_DEPARTAMENTO_EMPLEADO"],
                        NOMBRE_DEPARTAMENTO_EMPLEADO: (id_empleados === "0") ? "" : datos[0]["NOMBRE_DEPARTAMENTO_EMPLEADO"],
                        NOMBRE_CIUDAD_EMPLEADO: (id_empleados === "0") ? "" : datos[0]["NOMBRE_CIUDAD_EMPLEADO"],
                        CODIGO_MUNICIPIO_EMPLEADO: (id_empleados === "0") ? "" : datos[0]["CODIGO_MUNICIPIO_EMPLEADO"],
                        DIRECCION_EMPLEADO: (id_empleados === "0") ? "" : datos[0]["DIRECCION_EMPLEADO"],
                        SALARIO_INTEGRAL: (id_empleados === "0") ? "" : datos[0]["SALARIO_INTEGRAL"],
                        TIPO_CONTRATO: (id_empleados === "0") ? "" : datos[0]["TIPO_CONTRATO"],
                        CODIGO_TIPO_CONTRATO: (id_empleados === "0") ? "" : datos[0]["CODIGO_TIPO_CONTRATO"],
                        SUELDO_EMPLEADO: (id_empleados === "0") ? "" : datos[0]["SUELDO_EMPLEADO"],
                        TELEFONO_EMPLEADO: (id_empleados === "0") ? "" : datos[0]["TELEFONO_EMPLEADO"],
                        MEDIO_PAGO: (id_empleados === "0") ? "" : datos[0]["MEDIO_PAGO"],
                        CODIGO_MEDIO_PAGO: (id_empleados === "0") ? "" : datos[0]["CODIGO_MEDIO_PAGO"],
                        BANCO: (id_empleados === "0") ? "" : datos[0]["BANCO"],
                        CODIGO_BANCO: (id_empleados === "0") ? "" : datos[0]["CODIGO_BANCO"],
                        TIPO_CUENTA: (id_empleados === "0") ? "" : datos[0]["TIPO_CUENTA"],
                        NUMERO_CUENTA: (id_empleados === "0") ? "" : datos[0]["NUMERO_CUENTA"],
                        CODIGO_ENTIDAD_SALUD: (id_empleados === "0") ? "" : datos[0]["CODIGO_ENTIDAD_SALUD"],
                        DESCRIPCION_ENTIDAD_SALUD: (id_empleados === "0") ? "" : datos[0]["DESCRIPCION_ENTIDAD_SALUD"],
                        CODIGO_ENTIDAD_PENSION: (id_empleados === "0") ? "" : datos[0]["CODIGO_ENTIDAD_PENSION"],
                        DESCRIPCION_ENTIDAD_PENSION: (id_empleados === "0") ? "" : datos[0]["DESCRIPCION_ENTIDAD_PENSION"],
                        VALOR_CESANTIAS: (id_empleados === "0") ? "" : datos[0]["VALOR_CESANTIAS"],
                        VALOR_SALUD: (id_empleados === "0") ? "" : datos[0]["VALOR_SALUD"],
                        VALOR_PENSION: (id_empleados === "0") ? "" : datos[0]["VALOR_PENSION"],
                        FECHA_INGRESO: (id_empleados === "0") ? "" : datos[0]["FECHA_INGRESO"],
                        VALOR_RETIRO: (id_empleados === "0") ? "" : datos[0]["VALOR_RETIRO"],
                        AUXILIO_TRANSPORTE: (id_empleados === "0") ? 1 : datos[0]["AUXILIO_TRANSPORTE"],
                        USAR_NORMA_LEY: (id_empleados === "0") ? 1 : datos[0]["USAR_NORMA_LEY"],
                        departamentos,
                        ciudades,
                        medios_pago,
                        bancos,
                        tipos_empleados,
                        subtipos_empleados,
                        CORREO_EMPLEADO: (id_empleados === "0") ? "" : datos[0]["CORREO_EMPLEADO"] 
                    });

                } else {
                    this.setState({ mostrarMensaje: true, mensaje: data.message })
                }
            });

        this.setState({ id_empleados, titulo });
    }


    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    enviarInfo = () => {
        this.setState({ show: false });
        const { ID_EMPRESA, CODIGO_TIPO_EMPLEADO,CODIGO_SUBTIPO_EMPLEADO,TIPO_EMPLEADO,SUBTIPO_EMPLEADO,ALTO_RIESGO,TIPO_DOCUMENTO,DOCUMENTO_EMPLEADO,NOMBRE_1,NOMBRE_2,APELLIDO_1,APELLIDO_2,CODIGO_PAIS,CODIGO_DEPARTAMENTO_EMPLEADO,NOMBRE_DEPARTAMENTO_EMPLEADO,NOMBRE_CIUDAD_EMPLEADO,CODIGO_MUNICIPIO_EMPLEADO,DIRECCION_EMPLEADO,SALARIO_INTEGRAL,TIPO_CONTRATO,CODIGO_TIPO_CONTRATO,SUELDO_EMPLEADO,TELEFONO_EMPLEADO,MEDIO_PAGO,CODIGO_MEDIO_PAGO,BANCO,CODIGO_BANCO,TIPO_CUENTA,NUMERO_CUENTA,CODIGO_ENTIDAD_SALUD,DESCRIPCION_ENTIDAD_SALUD,CODIGO_ENTIDAD_PENSION,DESCRIPCION_ENTIDAD_PENSION,CORREO_EMPLEADO,AUXILIO_TRANSPORTE, USAR_NORMA_LEY } = this.state
        const  FECHA_INGRESO  = funciones.formatDate(this.state.FECHA_INGRESO); 
        const  FECHA_RETIRO  = funciones.formatDate(this.state.FECHA_RETIRO); 
        let ruta = "";
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                ID_EMPRESA,
                CODIGO_TIPO_EMPLEADO,
                TIPO_EMPLEADO,
                CODIGO_SUBTIPO_EMPLEADO,
                SUBTIPO_EMPLEADO,
                ALTO_RIESGO,
                TIPO_DOCUMENTO,
                DOCUMENTO_EMPLEADO,
                NOMBRE_1,
                NOMBRE_2,
                APELLIDO_1,
                APELLIDO_2,
                NOMBRE_COMPLETO: NOMBRE_1 + " " + NOMBRE_2 + " " + APELLIDO_1 + " " + APELLIDO_2,
                CODIGO_PAIS,
                CODIGO_DEPARTAMENTO_EMPLEADO,
                NOMBRE_DEPARTAMENTO_EMPLEADO,
                NOMBRE_CIUDAD_EMPLEADO,
                CODIGO_MUNICIPIO_EMPLEADO,
                DIRECCION_EMPLEADO,
                SALARIO_INTEGRAL,
                TIPO_CONTRATO,
                CODIGO_TIPO_CONTRATO,
                SUELDO_EMPLEADO,
                TELEFONO_EMPLEADO,
                MEDIO_PAGO,
                CODIGO_MEDIO_PAGO,
                BANCO,
                CODIGO_BANCO,
                TIPO_CUENTA,
                NUMERO_CUENTA,
                CODIGO_ENTIDAD_SALUD,
                DESCRIPCION_ENTIDAD_SALUD,
                CODIGO_ENTIDAD_PENSION,
                DESCRIPCION_ENTIDAD_PENSION,
                CORREO_EMPLEADO,
                FECHA_INGRESO,
                FECHA_RETIRO,
                AUXILIO_TRANSPORTE,
                USAR_NORMA_LEY
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
                'empresa': this.state.empresa
            }
        }

        if (this.state.id_empleados === "0") {
            ruta = config.servBackEnd + '/employee/create';
        } else {
            ruta = config.servBackEnd + '/employee/modify/' + this.state.id_empleados;
        }
        fetch(ruta, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const nuevoImpuesto = (data.data.insertId !== 0) ? data.data.insertId : this.state.id_empleados;
                    this.setState({ mostrarMensaje: true, mensaje: "Tarea Finalizada correctamente", id_empleados: nuevoImpuesto })
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Empleados con errores:" + errores[data.code] + " " + data.message })
                }
            });

    }

    validPayMethod=()=>{
        const currentmedio = this.state.CODIGO_MEDIO_PAGO;
        const  validacion={
            "1": false,
            "2": true,
            "3": true,
            "10": false,
            "13": true,
            "14": true,
            "20": false,
            "23": false,
            "25": false,
            "26": false,
            "30": true,
            "31": true,
            "42": true,
            "45": true,
            "46": true,
            "47": true,
            "48": true,
            "49": true,
            "71": false,
            "72": false,
            "92": false,
            "93": false,
        }
        return (validacion[currentmedio] || false)
    }


    render() {
        const mensajeBoton = (this.state.id_empleados === "0") ? 'Crear' : 'Modificar';
        const mensajeConfirm = (this.state.id_empleados === "0") ? '¿Esta seguro que desea crear el Empleado?' : '¿Esta seguro que desea modificar el Empleado?';
        const validacionUser = (this.state.tipo === '0' || this.state.tipo === '1' || this.state.tipo === '2');
        const { ciudades } = this.state;
        const { departamentos } = this.state;
        const { medios_pago } = this.state;
        const { bancos } = this.state;
        const { tipos_empleados } = this.state;
        const { subtipos_empleados } = this.state;
        const currentDep = this.state.CODIGO_DEPARTAMENTO_EMPLEADO;
        const show_bank = this.validPayMethod();
        // console.log(this.state)
        return (
            <div className="Formularioclientes">
                <Menu></Menu>
                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm} ></ModalConfirm>
                </div>
                <Jumbotron className="Jumbotron">
                    <h2>{this.state.titulo}</h2>
                </Jumbotron>
                {!validacionUser && <p>Usuario no valido para este modulo</p>}
                {validacionUser &&
                    <div>
                        <OverlayTrigger placement='top-start' overlay={<Tooltip>Volver a Empleados!</Tooltip>}>
                            <div className="div-back">
                                <a href="/empleados/">
                                    <img src={back} className="icon" alt="" />
                                </a>
                            </div>
                        </OverlayTrigger>
                        <Form className="form" onSubmit={this.handleSubmit}>
                            <Card className="card">
                                <Card.Header>
                                    <Nav variant="tabs" defaultActiveKey="#first">

                                        <Nav.Item>
                                            <Nav.Link href="#disabled" disabled>
                                                <h5>DATOS PERSONALES</h5>
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Card.Header>
                                <Card.Body>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>ID EMPRESA</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ ID_EMPRESA: e.target.value })} value={this.state.ID_EMPRESA} disabled />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>TIPO IDENTIFICACION</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ TIPO_DOCUMENTO: e.target.value })} value={this.state.TIPO_DOCUMENTO} required >
                                                <option value="">Seleccione</option>
                                                <option value="31">NIT</option>
                                                <option value="13">CEDULA CIUDADANIA</option>
                                                <option value="21">TARJETA DE EXTRANJERIA</option>
                                                <option value="22">CEDULA DE EXTRANJERIA</option>
                                                <option value="41">PASAPORTE</option>
                                                <option value="42">DOCUMENTO DE IDENTIFICACION EXTRANJERO</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>DOCUMENTO EMPLEADO</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ DOCUMENTO_EMPLEADO: e.target.value })} value={this.state.DOCUMENTO_EMPLEADO} required />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>PRIMER NOMBRE</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ NOMBRE_1: e.target.value.toUpperCase() })} value={this.state.NOMBRE_1} required />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>SEGUNDO NOMBRE</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ NOMBRE_2: e.target.value.toUpperCase() })} value={this.state.NOMBRE_2} />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>PRIMER APELLIDO</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ APELLIDO_1: e.target.value.toUpperCase() })} value={this.state.APELLIDO_1} required />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>SEGUNDO_APELLIDO</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ APELLIDO_2: e.target.value.toUpperCase() })} value={this.state.APELLIDO_2} required />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>DIRECCION EMPLEADO</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ DIRECCION_EMPLEADO: e.target.value.toUpperCase() })} value={this.state.DIRECCION_EMPLEADO} required />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridDepartamento">
                                            <Form.Label>DEPARTAMENTO</Form.Label>
                                            <Form.Control as="select" custom="true" onChange={e => this.setState({ CODIGO_DEPARTAMENTO_EMPLEADO: e.target.value, CODIGO_CIUDAD: "", NOMBRE_DEPARTAMENTO_EMPLEADO: e.target.selectedOptions[0].innerText })} value={this.state.CODIGO_DEPARTAMENTO_EMPLEADO} required>
                                                <option key='d' value="">--Seleccione Departamento--</option>
                                                {departamentos.map(function (currentData, index) {
                                                    return <option key={'d' + index} value={currentData.CODIGO_DEPARTAMENTO}>{currentData.NOMBRE_DEPARTAMENTO}</option>;
                                                })}
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridCiudad">
                                            <Form.Label>CIUDAD</Form.Label>
                                            <Form.Control as="select" custom="true" onChange={e => this.setState({ CODIGO_MUNICIPIO_EMPLEADO: e.target.value, NOMBRE_CIUDAD_EMPLEADO: e.target.selectedOptions[0].innerText })} value={this.state.CODIGO_MUNICIPIO_EMPLEADO} required>
                                                <option key='d' value="">--Seleccione Ciudad--</option>
                                                {ciudades.map(function (currentData, index) {
                                                    if (currentData.CODIGO_DEPARTAMENTO === currentDep) {
                                                        return <option key={'d' + index} value={currentData.CODIGO_DEPARTAMENTO + currentData.CODIGO_MUNICIPIO}>{currentData.NOMBRE_MUNICIPIO}</option>;
                                                    } else {
                                                        return null;
                                                    }
                                                })}
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>TELEFONO EMPLEADO</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ TELEFONO_EMPLEADO: e.target.value })} value={this.state.TELEFONO_EMPLEADO} required />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group>
                                        <Form.Label>CORREO EMPLEADO</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ CORREO_EMPLEADO: e.target.value })} value={this.state.CORREO_EMPLEADO} required />    
                                        </Form.Group>
                                    </Form.Row>
                                </Card.Body>
                            </Card>
                            <Card className="card">
                                <Card.Header>
                                    <Nav variant="tabs" defaultActiveKey="#first">

                                        <Nav.Item>
                                            <Nav.Link href="#disabled" disabled>
                                                <h5>DATOS DE PAGO</h5>
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Card.Header>
                                <Card.Body>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>MEDIO DE PAGO</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ CODIGO_MEDIO_PAGO: e.target.value, MEDIO_PAGO: e.target.selectedOptions[0].innerText })} value={this.state.CODIGO_MEDIO_PAGO} required >
                                                <option value="">Seleccione</option>
                                                {medios_pago.map(function (currentData, index) {
                                                    return <option key={'d' + index} className={currentData.REQUIERE_BANCO}  value={currentData.CODIGO_MEDIO_PAGO}>{currentData.DESCRIPCION_MEDIO_PAGO}</option>;
                                                })}
                                            </Form.Control>
                                        </Form.Group>
                                        {show_bank && 
                                            <Form.Group as={Col} controlId="">
                                                <Form.Label>BANCO</Form.Label>
                                                <Form.Control as="select" custom="true" onChange={e => this.setState({ CODIGO_BANCO: e.target.value, BANCO: e.target.selectedOptions[0].innerText })} value={this.state.CODIGO_BANCO} required>
                                                    <option key='d' value="">--Seleccione--</option>
                                                    {bancos.map(function (currentData, index) {
                                                        return <option key={'d' + index} value={currentData.CODIGO_BANCO}>{currentData.NOMBRE_BANCO}</option>;
                                                    })}
                                                </Form.Control>
                                            </Form.Group>
                                        }
                                        {show_bank &&                                     
                                            <Form.Group as={Col} controlId="">
                                                <Form.Label>TIPO DE CUENTA</Form.Label>
                                                <Form.Control as="select" onChange={e => this.setState({ TIPO_CUENTA: e.target.value })} value={this.state.TIPO_CUENTA} required >
                                                    <option value="">Seleccione</option>
                                                    <option value="1">AHORROS</option>
                                                    <option value="2">CORRIENTE</option>
                                                </Form.Control>
                                            </Form.Group>
                                        }
                                        {show_bank &&                                     
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>NÚMERO DE CUENTA</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ NUMERO_CUENTA: e.target.value.toUpperCase() })} value={this.state.NUMERO_CUENTA} required />
                                        </Form.Group>
                                         }
                                    </Form.Row>
                                </Card.Body>
                            </Card>

                            <Card className="card">
                                <Card.Header>
                                    <Nav variant="tabs" defaultActiveKey="#first">

                                        <Nav.Item>
                                            <Nav.Link href="#disabled" disabled>
                                                <h5>DATOS LABORALES</h5>
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Card.Header>
                                <Card.Body>
                                    <Form.Row>
                                        <Form.Group as={Col}>
                                            <Form.Label>FECHA INGRESO</Form.Label>
                                            <Form.Control type="date" value={funciones.formatDate(this.state.FECHA_INGRESO)} onChange={(e) => this.setState({ FECHA_INGRESO: e.target.value })} required/>
                                        </Form.Group>
                                        <Form.Group as={Col}>
                                            <Form.Label>FECHA RETIRO</Form.Label>
                                            <Form.Control type="date" value={funciones.formatDate(this.state.FECHA_RETIRO)} onChange={(e) => this.setState({ FECHA_RETIRO: e.target.value })} />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group controlId="" as={Col}>
                                            <Form.Label>TIPO EMPLEADO</Form.Label>
                                            <Form.Control as="select" custom="true" onChange={e => this.setState({ CODIGO_TIPO_EMPLEADO: e.target.value, TIPO_EMPLEADO: e.target.selectedOptions[0].innerText })} value={this.state.CODIGO_TIPO_EMPLEADO} required>
                                                <option key='d' value="">--Seleccione--</option>
                                                {tipos_empleados.map(function (currentData, index) {
                                                    return <option key={'d' + index} value={currentData.CODIGO_TIPO_EMPLEADO}>{currentData.DESCRIPCION_TIPO_EMPLEADO}</option>;
                                                })}
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group controlId="" as={Col}>
                                            <Form.Label>SUBTIPO EMPLEADO</Form.Label>
                                            <Form.Control as="select" custom="true" onChange={e => this.setState({ CODIGO_SUBTIPO_EMPLEADO: e.target.value, SUBTIPO_EMPLEADO: e.target.selectedOptions[0].innerText })} value={this.state.CODIGO_SUBTIPO_EMPLEADO} required>
                                                <option key='d' value="">--Seleccione--</option>
                                                {subtipos_empleados.map(function (currentData, index) {
                                                    return <option key={'d' + index} value={currentData.CODIGO_SUBTIPO_EMPLEADO}>{currentData.DESCRIPCION_SUBTIPO_EMPLEADO}</option>;
                                                })}
                                            </Form.Control>
                                        </Form.Group>

                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>ALTO RIESGO</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ ALTO_RIESGO: e.target.value })} value={this.state.ALTO_RIESGO} required >
                                                <option value="">Seleccione</option>
                                                <option value="1">SÍ</option>
                                                <option value="0">NO</option>
                                            </Form.Control>
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>SALARIO INTEGRAL</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ SALARIO_INTEGRAL: e.target.value })} value={this.state.SALARIO_INTEGRAL} required >
                                                <option value="">Seleccione</option>
                                                <option value="1">SÍ</option>
                                                <option value="0">NO</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>TIPO DE CONTRATO</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ CODIGO_TIPO_CONTRATO: e.target.value, TIPO_CONTRATO: e.target.selectedOptions[0].innerText })} value={this.state.CODIGO_TIPO_CONTRATO} required >
                                                <option value="">Seleccione</option>
                                                <option value="1">TERMINO FIJO</option>
                                                <option value="2">TERMINO INDEFINIDO</option>
                                                <option value="3">OBRA O LABOR</option>
                                                <option value="4">APRENDIZAJE</option>
                                                <option value="5">PRACTICAS O PASANTIAS</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>SUELDO</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ SUELDO_EMPLEADO: e.target.value.toUpperCase() })} value={this.state.SUELDO_EMPLEADO} required />
                                        </Form.Group>

                                    </Form.Row>
                                </Card.Body>
                            </Card>

                            <Card className="card">
                                <Card.Header>
                                    <Nav variant="tabs" defaultActiveKey="#first">

                                        <Nav.Item>
                                            <Nav.Link href="#disabled" disabled>
                                                <h5>SEGURIDAD SOCIAL Y PRESTACIÓN SOCIAL</h5>
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Card.Header>
                                <Card.Body>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>EPS</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ CODIGO_ENTIDAD_SALUD: e.target.value, DESCRIPCION_ENTIDAD_SALUD: e.target.selectedOptions[0].innerText })} value={this.state.CODIGO_ENTIDAD_SALUD} required >
                                                <option value="">Seleccione</option>
                                                <option value="1">NUEVA EPS</option>
                                                <option value="2">COOSALUD</option>
                                                <option value="3">EPS SURA</option>
                                                <option value="4">COMFENALCO VALLE</option>
                                                <option value="5">SALUD TOTAL</option>
                                                <option value="6">EMSSANAR</option>
                                                <option value="7">COOMEVA</option>
                                                <option value="8">COMFANDI</option>
                                                <option value="9">COSMITET</option>
                                                <option value="10">SANITAS</option>
                                                <option value="11">SOS</option>
                                                <option value="12">COMPENSAR</option>
                                                <option value="13">ASMESALUD</option>
                                            </Form.Control>
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>PENSION</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ CODIGO_ENTIDAD_PENSION: e.target.value, DESCRIPCION_ENTIDAD_PENSION: e.target.selectedOptions[0].innerText })} value={this.state.CODIGO_ENTIDAD_PENSION} required >
                                                <option value="">Seleccione</option>
                                                <option value="1">COLPENSIONES</option>
                                                <option value="2">COLFONDOS</option>
                                                <option value="3">PORVENIR</option>
                                                <option value="4">PROTECCION</option>
                                                <option value="5">SKANDIA</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>VALOR CESANTIAS</Form.Label>
                                            <Form.Control type="text" defaultValue={this.state.VALOR_CESANTIAS} disabled />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                    <Form.Group as={Col} controlId="">
                                        <Form.Label>USAR LEY CALCULO AUXILIO TRANSPORTE</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ USAR_NORMA_LEY: e.target.value })} value={this.state.USAR_NORMA_LEY} required >
                                                <option value={1}>SI</option>
                                                <option value={0}>NO</option>
                                            </Form.Control>
                                        </Form.Group>  
                                        {(this.state.USAR_NORMA_LEY===0 || this.state.USAR_NORMA_LEY==="0") && 
                                            <Form.Group as={Col} controlId="">                                
                                            <Form.Label>DEVENGA AUXILIO TRANSPORTE</Form.Label>
                                                <Form.Control as="select" onChange={e => this.setState({ AUXILIO_TRANSPORTE: e.target.value })} value={this.state.AUXILIO_TRANSPORTE} required >
                                                    <option value={1}>SI</option>
                                                    <option value={0}>NO</option>
                                                </Form.Control>
                                            </Form.Group>
                                        }
            
                                    </Form.Row>
                                </Card.Body>
                            </Card>

                            <Button variant="primary" type="submit">{mensajeBoton}</Button>

                        </Form>

                    </div>
                }
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </div>
        );
    }
}
export default (Formularioclientes);